module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="modal fade bs-example-modal-sm" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">\n    <div class="modal-dialog modal-sm">\n        <div class="modal-content">\n            <div class="modal-header" style="border:none">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n            </div>\n            <div class="modal-body">\n                <div class="list-group">\n                    ';
 for (var i = 0; i < languageList.length; i++) {;
__p += '\n                    <a class="list-group-item" id="' +
((__t = (languageList[i].code)) == null ? '' : __t) +
'">' +
((__t = (languageList[i].name)) == null ? '' : __t) +
'</a>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n        </div>\n    </div>\n</div>';

}
return __p
}